import React, { useCallback, useMemo } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import { buyPrizeModalContent } from '../../../constants/copyright';
import CustomButton from '../../features/customButton/ui/main/CustomButton';

const BuyPrizeModal = React.forwardRef(function BuyPrizeModal({ item, callbacks }, ref) {
  const { buttons } = buyPrizeModalContent;
  const { closeModal } = useModal();

  const close = useCallback(() => closeModal({ type: 'all' }), []);

  const buyModalCallbacks = useMemo(
    () => ({
      buy: () => (callbacks.buyItem(item.id), close()),
      cancel: close,
    }),
    [item.id],
  );

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={'buy-prize-modal'} ref={ref}>
        <div className='buy-prize-modal__bg' onClick={close} />
        <div className='buy-prize-modal__content'>
          <h2 className='buy-prize-modal__title'>{safeHTML(`Вы хотите купить приз \nза ${item.cost} монет`)}</h2>
          <div className='buy-prize-modal__buttons'>
            {buttons.map((el, id) => (
              <CustomButton key={`b${id}`} {...el.attr} onClick={buyModalCallbacks[el.action]} />
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  );
});
export default BuyPrizeModal;
BuyPrizeModal.propTypes = {};
